module.exports = __webpack_public_path__ + "static/media/blue.33ae8d32.gif";